import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../services/api.service';
import { Utenteservice } from '../../services/utente.service';
import { EditgruppiComponent } from '../editgruppi/editgruppi.component';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';

@Component({
  selector: 'app-gruppi',
  templateUrl: './gruppi.component.html',
  styleUrls: ['./gruppi.component.css']
})
export class GruppiComponent implements OnInit {
//#dynamicInsertFormComponent
  @ViewChild('uGruppi', { static: true }) uGruppi: NicaAnagraficaComponent;
  @ViewChild('dynamicInsertFormComponent', { static: true }) dynamicInsertFormComponent: NicaAnagraficaComponent;
  @Input() itemData: any
  
  myFilterGruppi:string='';
  constructor(private _overlaySidePanelService: OverlaySideFormService,
    private apiService:Apiservice,
    private spinner: NgxSpinnerService,private appService:Apiservice,
    public utenteService:Utenteservice,) { 

    this._overlaySidePanelService.onPanelClose().subscribe(data=>{
      this.uGruppi.refresh();
    })
    }

  ngOnInit() {
  }

  openEdit(value,stato){
    //let Gruppo = e.data;
    let Gruppo = value;

    //alert(Gruppo["id"])
    this._overlaySidePanelService.setToolBarVisible(false)    
    
    this._overlaySidePanelService.setPopupWidth(undefined);
    this._overlaySidePanelService.setPopupHeight(undefined);
    if(stato=='edit')
    this._overlaySidePanelService.setTitle("Dettagli Permessi gruppo : " + Gruppo.descrizione); else
    this._overlaySidePanelService.setTitle("Nuovo Gruppo");
    this._overlaySidePanelService.setContent(EditgruppiComponent);
    let data = [
      {
        IdTabella: Gruppo["id"],          
        dati: Gruppo,
        masterKey: 'id',
        InviaA:'gruppi'
      }
    ]
    this._overlaySidePanelService.sendDataToComponent(data);
    
    setTimeout(() => {
      this._overlaySidePanelService._hrefComponent.instance.inizializza();
    }, 500);
    this._overlaySidePanelService.show();
  }


  AllEventGruppi(e){
    console.log(e.name);
    
    if (e.name == 'onInitNewRow') {
      //this.uPermessi.griglia.instance.clearFilter();
      
      e.cancel = true;
      this.appService.GetApi('Gruppo/0').then(response => {
        console.log(response)
        response["id"]=0;
        response['isAttivo']=true,
        response['descrizione']='';
        this.openEdit(response,'insert');
      })
      //console.log("che stronzata ",this)
    }


//onEditingStart

    if (e.name == 'onEditorPrepared') {
      e.cancel = true;
      let Gruppo = e.data;
      this.openEdit(Gruppo,'edit');

    }




    if (e.name == 'onSaving') {
      //this.uPermessi.griglia.instance.clearFilter();
      //e.cancel = true;
      //console.log("che stronzata ",this)
    }
  }
  preparaToolbarCopiaIncollaGruppi(e){

  }
  optionalButtonClick2Gruppi(e){
   

  }
  checkGetAllGruppi(e){

    console.log("Ecco i gruppi ",e)
    let rispo = {
      items: []
    }
    //rispo.items = e.data[0].funzioni;
    return null;

  }
}
